import React from "react";
import type { IconProps } from "./type";

const TravelIconDark = ({ color = "black" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1667 1.66666C12.3258 1.66666 10.8334 3.15904 10.8334 4.99999C10.8334 6.84094 12.3258 8.33332 14.1667 8.33332C16.0077 8.33332 17.5001 6.84094 17.5001 4.99999C17.5001 3.15904 16.0077 1.66666 14.1667 1.66666Z"
        fill={color}
      />
      <path
        d="M11.6667 9.16666C11.3454 9.16666 11.0347 9.21213 10.7406 9.297C10.6114 9.95868 10.3517 10.5737 9.98944 11.1141C11.6834 11.7085 12.9605 13.1892 13.2643 15H16.6667C17.5872 15 18.3334 14.2538 18.3334 13.3333V12.5C18.3334 10.659 16.841 9.16666 15.0001 9.16666H11.6667Z"
        fill={color}
      />
      <path
        d="M2.50002 8.33332C2.50002 6.49237 3.9924 4.99999 5.83335 4.99999C7.6743 4.99999 9.16669 6.49237 9.16669 8.33332C9.16669 10.1743 7.6743 11.6667 5.83335 11.6667C3.9924 11.6667 2.50002 10.1743 2.50002 8.33332Z"
        fill={color}
      />
      <path
        d="M1.66669 15.8333C1.66669 13.9924 3.15907 12.5 5.00002 12.5H8.33335C10.1743 12.5 11.6667 13.9924 11.6667 15.8333V16.6667C11.6667 17.5871 10.9205 18.3333 10 18.3333H3.33335C2.41288 18.3333 1.66669 17.5871 1.66669 16.6667V15.8333Z"
        fill={color}
      />
    </svg>
  );
};

export default TravelIconDark;
